import React, { useState, useEffect } from "react";
import "./Subhead.css";
import { handleButtonClickEventBuilder, sendEvent } from "../../utils/event-helpers";
import NewStarIcon from '@mui/icons-material/Star';
import SeenStarIcon from '@mui/icons-material/StarBorder';
import { useAppSelector } from "../../app/store";

const Subhead = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { userId, sessionId } = useAppSelector((state) => state.session);
  const recommendations = useAppSelector((state) => state.mentorRecommendations.data);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const menuItems = [
    {
      path: '/recommenderpage/get-research-experience',
      fullName: 'Get Research Experience',
      shortName: 'Research Experience'
    },
    {
      path: '/recommenderpage/explore-careers',
      fullName: 'Explore Careers',
      shortName: 'Careers'
    },
    {
      path: '/recommenderpage/find-graduate-schools',
      fullName: 'Find Graduate Schools',
      shortName: 'Grad School'
    },
    {
      path: '/recommenderpage/talk-to-an-expert',
      fullName: 'Talk to an Expert',
      shortName: 'Experts'
    },
    {
      path: '/recommenderpage/find-internships',
      fullName: 'Find Internships',
      shortName: 'Internships'
    }
  ];

  function recommendedStar(seen: boolean): React.ReactNode {
    return <div style={{
      position: 'absolute',
      right: 0,
      top: 0,
    }}> {seen ? <SeenStarIcon /> : <NewStarIcon />} </div>;
  }

  return (
    <div className={`subhead-container`}>
      {menuItems.map((item, index) => {

        const isRecommendedPage = recommendations?.recommendedPages.find(page => item.path.includes(page.pageRoute));
        return <a 
        key={index}
        href={item.path}
        onClick={() => {
          const eventData = handleButtonClickEventBuilder(userId, sessionId, item.fullName, {});
          sendEvent(eventData);
        }}
        className="subhead-option"
      >
        {isRecommendedPage && recommendedStar(isRecommendedPage.seen)}
        {isMobile ? item.shortName : item.fullName}
      </a>
      })}
    </div>
  );
};

export default Subhead;
